module.exports = __webpack_public_path__ + "img/university_10.16163469.png";